import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "roomTableTr"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "fw600 fs16" }
const _hoisted_4 = {
  key: 2,
  class: "label dgreyBorder fs11"
}
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(`posRe`)
}
const _hoisted_6 = { class: "w100" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"3px","margin-left":"-3px"} }, " 調整ページへ", -1)
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"3px","margin-left":"-3px"} }, " 履歴", -1)
const _hoisted_11 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`fw400 fl centered fs12 blueAround pointer ml9`),
  style: {"width":"120px","padding":"4px 10px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_UserStatusCell = _resolveComponent("UserStatusCell")!

  return (_ctx.room)
    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
        _createElementVNode("td", {
          class: _normalizeClass(`pad10 roomTableTd centered fs16 ${_ctx.bgColor()}`),
          style: {"width":"200px"}
        }, [
          _createElementVNode("label", {
            class: _normalizeClass(`fs11 ${_ctx.roomLabels()}`)
          }, _toDisplayString(_ctx.room.status_name), 3),
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.room.current_appointment.name), 1),
          (_ctx.room)
            ? (_openBlock(), _createBlock(_component_tooltip, {
                key: 0,
                text: "コピーしました!",
                trigger: "manual",
                modelValue: _ctx.showTip,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showTip) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "fs13 ddgreyColor",
                    style: {"line-height":"12px"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyPublicId && _ctx.copyPublicId(...args)))
                  }, _toDisplayString(_ctx.room.public_id), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.room)
            ? (_openBlock(), _createBlock(_component_tooltip, {
                key: 1,
                text: "コピーしました!",
                trigger: "manual",
                modelValue: _ctx.showAppoTip,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAppoTip) = $event))
              }, {
                default: _withCtx(() => [
                  (_ctx.room.current_appointment.status == 10)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "fs10 ddgreyColor",
                        style: {"line-height":"12px"},
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyAppoText && _ctx.copyAppoText(...args)))
                      }, _toDisplayString(_ctx.room.current_appointment.jp_format), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.personInCharge().length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "担当: " + _toDisplayString(_ctx.personInCharge()), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("td", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(`fl fw400 pad10`),
            style: _normalizeStyle({
                    marginTop: _ctx.isSP ? `0px` : ``,
                })
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", {
                class: _normalizeClass(`fw400 fl centered fs12 blueAround pointer ml9`),
                style: {"width":"110px","padding":"4px 10px"},
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickRoom && _ctx.clickRoom(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/pageicon.png`),
                  width: "13",
                  height: "13",
                  style: {"margin-top":"-2px"}
                }, null, 8, _hoisted_7),
                _hoisted_8
              ]),
              _createElementVNode("label", {
                class: _normalizeClass(`fw400 fl centered fs12 blueAround pointer ml9`),
                style: {"width":"110px","padding":"4px 10px"},
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showHistory && _ctx.showHistory(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/menu_icon01.png`),
                  width: "13",
                  height: "13",
                  style: {"margin-top":"-2px"}
                }, null, 8, _hoisted_9),
                _hoisted_10
              ]),
              (_ctx.room.room_type == `parent_room` && _ctx.room.public_room_id)
                ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
                    _createElementVNode("span", {
                      style: {"margin-top":"3px","margin-left":"-3px"},
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goSummaryFromParent && _ctx.goSummaryFromParent(...args)))
                    }, " 公開ページへ移動 ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendees, (mem, memindex) => {
              return (_openBlock(), _createBlock(_component_UserStatusCell, {
                key: `${mem.id}${_ctx.room.id}${memindex}`,
                room: _ctx.room,
                mem: mem,
                showIcon: false,
                onClick: _withModifiers(_ctx.clickRoom, ["self"]),
                onClickRemind: _ctx.clickRemind,
                onClickFormMember: _ctx.clickFormMember
              }, null, 8, ["room", "mem", "onClick", "onClickRemind", "onClickFormMember"]))
            }), 128))
          ], 4)
        ]),
        _hoisted_13
      ]))
    : _createCommentVNode("", true)
}